module.exports = __webpack_public_path__ + "img/wizovic.90e9613.png";